import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './candidateBodySection.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import myCandidateImage from '../../../../assets/images/candidateHandImage.jpeg';
import { useNavigate } from 'react-router-dom';
import RegisterFlow from '../../../homepage/registerflow/registerflow';
const contents = [
    {
        title: (
            <>
                Better <span>Visibility .</span> <br></br>More Opportunities
            </>
        ),
        description:
            'Gain visibility with top organizations seeking dynamic leaders to drive teams and shape the future',
    },
    {
        title: (
            <>
                Discreet <span>Search</span> <br></br>Stealth Mode
            </>
        ),
        description:
            "Your profile stays confidential and is accessible only to verified employers under Leaderly’s premium plan",
    },
    {
        title: (
            <>
                Robust <span>Security .</span> <br></br>Zero Breaches
            </>
        ),
        description:
            'We safeguard your personal information with strict security measures, ensuring it remains private and protected at all times.',
    },
    {
        title: (
            <>
                Expert <span>Help ,</span><br /> Frequent Insights
            </>
        ),
        description: 'Get one-on-one support from a dedicated POC, ensuring clarity, efficiency, and the best outcomes ',
    },
];

const CandidateBodySection = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [hovered, setHovered] = useState(false);
    const navigate = useNavigate();

    const handleJoinClick = () => {
        navigate('/login');
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % contents.length);
        }, 7000);

        return () => clearInterval(interval);
    }, []);

    const handleForwardClick = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % contents.length);
        setHovered(true);
        setTimeout(() => setHovered(false), 500);
    };

    const handleBackwardClick = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + contents.length) % contents.length);
        setHovered(true);
        setTimeout(() => setHovered(false), 500);
    };

    const handleLinkClick = (index, event) => {
        event.preventDefault();
        setCurrentIndex(index);
    };
    const handleKnowMoreClick = () => {
        if (!sessionStorage.getItem("initialScrollPosition")) {
            sessionStorage.setItem("initialScrollPosition", window.scrollY);
        }
        sessionStorage.setItem("scrollPosition", window.scrollY);
        window.location.href = "/pricing-prelogin";
    };
    const [registerPopupVisible, setRegisterPopupVisible] = useState(false);

    const openRegisterPopup = () => {
        setRegisterPopupVisible(true);
    };

    const closeRegisterPopup = () => {
        setRegisterPopupVisible(false);
    };
    return (
        <div className="candidate-body-section">
            <Container className="candidate-container-style">
                <Row>
                    <Col md={6}>
                        <div className="candidate-left-container">
                            <div className="candidate-left-heading-container">
                                <h2 className="candidate-left-heading">
                                    Why <br /> Join Us ?
                                </h2>
                            </div>
                            <div className='candidate-link-p'>Join Leaderly to access exclusive senior leadership opportunities with top organizations seeking verified and high-caliber professionals. </div>
                            <div className="d-flex justify-content-between mt-10 candidate-left-confidentiality-lorem-container">
                                {contents.map((_, index) => (
                                    <a
                                        key={index}
                                        href="#"
                                        className={currentIndex === index ? 'candidate-active-link' : ''}
                                        onClick={(e) => handleLinkClick(index, e)}
                                    >
                                        {index === 0 && 'Access'}
                                        {index === 1 && 'Confidential'}
                                        {index === 2 && 'Secure'}
                                        {index === 3 && 'Personalised'}
                                    </a>
                                ))}
                            </div>
                            <div className="candidate-left-button-container">
                                <button className="candidate-left-button" onClick={openRegisterPopup} >Register for Free</button>
                            </div>
                            <RegisterFlow visible={registerPopupVisible} onClose={closeRegisterPopup} />
                        </div>
                    </Col>

                    <Col md={6}>
                        <div className="candidate-right-container">
                            <div className="candidate-right-content-image">
                                <img src={myCandidateImage} alt="Image of hand shield" className="candidate-hand-image" />
                            </div>
                            <div className="candidate-right-info-container">
                                <div className="candidate-right-icon-container">
                                    <div className='candidate-right-icon'>

                                        <FontAwesomeIcon
                                            icon={faAngleLeft}
                                            className="candidate-right-icon-backward"
                                            onClick={handleBackwardClick}
                                        /></div>
                                    <div className='candidate-right-icon'>
                                        <FontAwesomeIcon
                                            icon={faAngleRight}
                                            className="candidate-right-icon-forward"
                                            onClick={handleForwardClick}
                                        />
                                    </div></div>
                                <div className="candidate-right-info-text">
                                    <p className="candidate-right-info-1">{contents[currentIndex].title}</p>
                                    <p className="candidate-right-info-2">{contents[currentIndex].description}</p>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default CandidateBodySection;